/**
 * Billing Module - Frontend
 *
 * Expone la página Billing (facturación, características del sistema y precios)
 * bajo /billing. La API sigue en /api/settings/features y /api/settings/billing.
 *
 * Referencia: MODULE_SYSTEM_README.md, GUIA_CREACION_MODULOS.md
 */

export const billingModuleRoutes = [
  {
    path: "billing",
    name: "Billing",
    component: () => import("./pages/SystemFeatures.vue"),
    meta: { title: "Billing" },
  },
  {
    path: "systemfeatures",
    name: "SystemFeaturesPage",
    component: () => import("./pages/SystemFeatures.vue"),
    meta: { title: "System Features", billingDefaultTab: "features" },
  },
];

export default {
  name: "billing_module",
  routes: billingModuleRoutes,
};
